import type { VoidFunctionComponent } from 'react';
import Text from '../../generic/Text';
import Button from '../../generic/Button';
import styles from './DisplaySBOMPolicyPage.module.less';

type HeaderComponentProps = {
  handleSavePolicyRule: () => void,
  isDirty: boolean,
};

const HeaderComponent: VoidFunctionComponent<HeaderComponentProps> = ({
  handleSavePolicyRule,
  isDirty,
}) => {
  return (
    <div className={`${styles.headerContainer}`}>
      <div>
        <Text.H1>SBOM Policy</Text.H1>
        <p>SBOMs imported with this policy must adhere to these rules.</p>
      </div>
      <div>
        <Button type="primary" size="large" isDisabled={!isDirty} onClick={handleSavePolicyRule}>
          Save
        </Button>
      </div>
    </div>
  );
};

export default HeaderComponent;
